export enum MachineCommandsIconEnum {
  reboot = 'restart_alt',
  shutdown = 'power_settings_new',
  reloadScheduler = 'sync',
  switchOnProjector = 'videocam',
  switchOffProjector = 'videocam_off',
  switchOnScreen = 'cast',
  switchOffScreen = 'cancel_presentation',
}
